// extracted by mini-css-extract-plugin
export default {"roulette":"Roulette_roulette__FGVVO","target":"Roulette_target__WzWow","result":"Roulette_result__Hvp2k","fadeIn":"Roulette_fadeIn__AXyHH"};